import { z } from 'zod';

/**
 * Asset class dropdown row. Sourced from asset_class WHERE is_active,
 * ordered by display_order.
 */
export const assetClassSchema = z.object({
  id: z.string(),
  name: z.string(),
  parentId: z.string().nullable(),
  specDisplaySchema: z.unknown(),
});

export type AssetClass = z.infer<typeof assetClassSchema>;

export const assetClassListResponseSchema = z.object({
  data: z.array(assetClassSchema),
});
export type AssetClassListResponse = z.infer<typeof assetClassListResponseSchema>;
